import React, { useCallback, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Lock, ShieldCheck, CreditCard, Flame, ChevronRight } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
const CART_URL = 'https://omanualproibido.com.br/oferta-especial/?funnel=fn26a5a0d6&step=86&actionId=565400&currentStepId=446780&previousStepId=446768&rda=false&referrer=https%3A%2F%2Fwww.facebook.com%2F';
const TIMER_DURATION = 10 * 60;
export function PricingOfferSection() {
  const [timeLeft, setTimeLeft] = useState(TIMER_DURATION);
  const [isUrgent, setIsUrgent] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => prev <= 1 ? TIMER_DURATION : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    setIsUrgent(timeLeft <= 120);
  }, [timeLeft]);
  const handleCtaClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Manual de Seducción Prohibida',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
  };
  return <section id="pricing-offer" className="py-20 sm:py-28 bg-[#080808] relative overflow-hidden" data-id="element-86">
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-crimson/8 via-transparent to-transparent opacity-60 pointer-events-none" data-id="element-87" />

      <div className="max-w-4xl mx-auto px-5 sm:px-6 relative z-10" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-89">
          {/* Urgency badge */}
          <div className={`inline-flex items-center gap-2 px-5 py-2 rounded-full mb-8 border transition-colors duration-500 ${isUrgent ? 'bg-red-950/50 border-red-700/50 text-red-300' : 'bg-crimson/10 border-crimson/20 text-crimson-light'}`} data-id="element-90">
            <Flame size={14} className={isUrgent ? 'text-red-400 animate-pulse' : 'text-crimson'} data-id="element-91" />
            <span className="text-sm font-bold uppercase tracking-wider" data-id="element-92">
              Oferta de lanzamiento — Solo por hoy
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-3 leading-tight" data-id="element-93">
            Accedé al sistema completo
          </h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-94">
            El Manual + Audiobook + Videos + Guía +{' '}
            <span className="text-gold font-semibold" data-id="element-95">4 Bonos Gratis</span>
          </p>

          {/* Product mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="mb-10 relative inline-block" data-id="element-96">
            <div className="absolute inset-0 bg-crimson/10 blur-[50px] rounded-full pointer-events-none" data-id="element-97" />
            <img src="https://cdn.magicpatterns.com/uploads/dUCumyGdRDtNLM4eLMGY7t/Generated_Image_February_11,_2026_-_11_47PM.jpg" alt="Manual de Seducción Prohibida" className="relative w-full max-w-xs sm:max-w-sm mx-auto rounded-lg shadow-2xl border border-white/10" data-id="element-98" />
          </motion.div>

          {/* Countdown */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="mb-8" data-id="element-99">
            <p className="text-sm text-gray-500 uppercase tracking-[0.15em] mb-4 flex items-center justify-center gap-2" data-id="element-100">
              <Clock size={14} className="text-crimson" data-id="element-101" />
              Este precio se va en
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-102">
              <div className="flex flex-col items-center" data-id="element-103">
                <div className={`text-5xl sm:text-6xl font-black tabular-nums tracking-tight transition-colors duration-500 ${isUrgent ? 'text-red-400' : 'text-white'}`} data-id="element-104">
                  {Math.floor(timeLeft / 60).toString().padStart(2, '0')}
                </div>
                <span className="text-[10px] text-gray-600 uppercase tracking-widest mt-1" data-id="element-105">
                  min
                </span>
              </div>
              <div className={`text-4xl sm:text-5xl font-black mb-5 animate-pulse ${isUrgent ? 'text-red-400' : 'text-crimson'}`} data-id="element-106">
                :
              </div>
              <div className="flex flex-col items-center" data-id="element-107">
                <div className={`text-5xl sm:text-6xl font-black tabular-nums tracking-tight transition-colors duration-500 ${isUrgent ? 'text-red-400' : 'text-white'}`} data-id="element-108">
                  {(timeLeft % 60).toString().padStart(2, '0')}
                </div>
                <span className="text-[10px] text-gray-600 uppercase tracking-widest mt-1" data-id="element-109">
                  seg
                </span>
              </div>
            </div>
          </motion.div>

          {/* Dynamic Price */}
          <div className="mb-3" data-id="element-110">
            <PriceDisplay basePrice={27} originalPrice={97} showOriginal={true} originalClassName="text-gray-500 line-through text-2xl sm:text-3xl font-medium" priceClassName="text-5xl sm:text-6xl font-black text-crimson" data-id="element-111" />
          </div>

          {/* Savings */}
          <div className="mb-10" data-id="element-112">
            <span className="inline-block bg-crimson/10 text-crimson-light text-sm font-bold px-5 py-2 rounded-full border border-crimson/20" data-id="element-113">
              Ahorrás 72% — Precio de lanzamiento
            </span>
          </div>

          {/* CTA Button */}
          <a href={CART_URL} onClick={handleCtaClick} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-3 font-black text-lg sm:text-xl py-5 sm:py-6 px-10 sm:px-16 rounded transition-all duration-300 w-full sm:w-auto text-center uppercase tracking-wider ${isUrgent ? 'bg-crimson hover:bg-crimson-light text-white shadow-[0_0_60px_rgba(220,38,38,0.5)] animate-pulse' : 'bg-crimson hover:bg-crimson-light text-white shadow-[0_0_40px_rgba(220,38,38,0.35)]'}`} data-id="element-114">
            ¡Quiero mi copia ahora!
            <ChevronRight size={22} className="group-hover:translate-x-1 transition-transform" data-id="element-115" />
          </a>

          {/* Trust elements */}
          <div className="mt-8 flex flex-col items-center gap-4" data-id="element-116">
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-gray-500" data-id="element-117">
              <div className="flex items-center gap-1.5" data-id="element-118">
                <Lock size={13} className="text-green-500" data-id="element-119" />
                <span data-id="element-120">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-121">
                <ShieldCheck size={13} className="text-green-500" data-id="element-122" />
                <span data-id="element-123">Datos Protegidos con SSL</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-124">
                <CreditCard size={13} className="text-gray-500" data-id="element-125" />
                <span data-id="element-126">Visa · Mastercard · PayPal</span>
              </div>
            </div>
            <p className="text-xs text-gray-600" data-id="element-127">
              Acceso inmediato después del pago · Descarga digital
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}